import {updatePersonInState} from "./actionHelpers";

export default function updateVitalStatus(state, action){
    let personToUpdate = state.people[action.person_index];
    let val = action.status;
    let person = Object.assign({}, personToUpdate, {
        deceased: val,
    });
    return updatePersonInState(state, action.person_index, person);
}